import { Badge } from '@mantine/core';

export default Badge.extend({
	defaultProps: {
		size: 'sm',
		radius: 'xs',
		variant: 'light'
	},
	classNames: {
		root: 'font-normal'
	}
});
